import { useAtomValue } from 'jotai';
import { Stack, Text } from '@pairy/pds-react';

import PlanFeatureMatrix from '../PlanFeatureMatrix';
import { normalizePlanName } from '../PlanFeatureMatrix/index.constants';
import { CouponAppliedAtom, SelectedPlanAtom } from '../index.atom';

import * as Styled from './index.styles';

const PlanComparisonPanel = () => {
  const selectedPlan = useAtomValue(SelectedPlanAtom);
  const isCouponApplied = useAtomValue(CouponAppliedAtom);

  return (
    <Styled.Wrapper gap={16} direction="column" width="100%">
      {isCouponApplied && (
        <Styled.CouponWrapper
          gap={8}
          width="100%"
          direction="column"
          backgroundColor="viridian_600"
          padding={32}
        >
          <Text variant="xl-semibold" color="viridian_50">
            쿠폰을 적용하시면 할인된 금액으로 결제됩니다
          </Text>

          <Text variant="md-medium" color="viridian_50">
            할인 혜택 적용 기간: 쿠폰 발급 시 고지되었던 기간까지
          </Text>
        </Styled.CouponWrapper>
      )}

      <Styled.MatrixWrapper gap={16} direction="column" padding={24}>
        <Stack gap={4} direction="column">
          <Text as="h2" variant="xl-semibold" color="black">
            플랜별 기능 비교
          </Text>
          <Text variant="md-regular" color="zinc_500">
            플랜을 선택하면 해당 열이 강조됩니다.
          </Text>
        </Stack>

        <PlanFeatureMatrix
          highlightedPlan={normalizePlanName(selectedPlan?.name)}
        />
      </Styled.MatrixWrapper>
    </Styled.Wrapper>
  );
};

export default PlanComparisonPanel;
